import { Button, Stack } from '@mui/material';
import PersianSupportTextField from 'Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField';
import SingleReactHookFormWrapper from 'Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import SubmitNormalLoginData from 'Routes/Public/Login/Functions/SubmitNormalLoginData';
import styles from '../../../Styles/Login.Normal.Forms.module.scss';
import i18next from 'i18next';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { GetURLQuery } from 'utils/GetURLQuery';
import GetPostResponse from 'Global/Functions/GetPostResponse/GetPostResponse';
import { Post } from 'Xhr/Xhr';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { useLoginWithTakafol } from 'Routes/Public/Login/Hooks/useLoginWithTakafol';


const LoginFormInputs = () => {



  const { control, formState, handleSubmit,getValues } = useForm({
    defaultValues: {
      username: '',
      password: '',
    },
  });
  const GlobalConstants = useContext(GlobalContext);
  const navigate = GlobalConstants.navigate;
  const languageArray =
    useContext(GlobalContext)?.LanguageArray;

  const username_hint = FindLangKey('login-username-hint');

  const {setIsSSO,code,sso_token} =useLoginWithTakafol(getValues,navigate)


  return (
    <div
      className={styles.loginForms}
      dir="rtl"
      style={{ marginTop: 0 }}
    >
      <form
        className={styles.loginForms}
        dir="rtl"
        onSubmit={handleSubmit((data) =>{

          if(code||sso_token){
            setIsSSO({});
            return
          }

          SubmitNormalLoginData(data, navigate)

        }
        )}
      >
        <Stack gap="1em">
          <p
            style={{
              fontSize: '.8em',
              fontWeight: 'bold',
            }}
          >
            {username_hint}
          </p>
          <SingleReactHookFormWrapper
            element={
              <PersianSupportTextField
                label={FindLangKey(
                  'login-input-user-name',
                  languageArray
                )}
                isEnglish={i18next?.language === 'en'}
              />
            }
            control={control}
            errors={formState.errors}
            name="username"
            required={true}
          />
        </Stack>
        <SingleReactHookFormWrapper
          element={
            <PersianSupportTextField
              label={FindLangKey(
                'general-public-password-key',
                languageArray
              )}
              isEnglish={i18next?.language === 'en'}
            />
          }
          control={control}
          errors={formState.errors}
          name="password"
          isPassword={true}
          required={true}
        />
        <Button
          fullWidth
          color="colorPrimer"
          variant="contained"
          type="submit"
          sx={{
            minHeight: '40px',
            color: `${themeColors.ColorPrimary} !important`,
          }}
        >
          {FindLangKey('login-button-enter', languageArray)}
        </Button>
      </form>
    </div>
  );
};

export default LoginFormInputs;
